import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import {
    Box,
    Collapse,
    IconButton
} from '@mui/material';
import React from 'react';
import {CustomCheckbox} from '../CustomCheckbox';
import {
    CustomDropdownMenuStyles, CustomStyleTable,
} from "../Styles";

import {getDateFormat} from "../../Apis/functions";
import EllipsisCell from "./EllipsisCell";
import CustomTooltip from "../CustomTooltip";
import CustomExpandableTableApp from "./Functionality/CustomExpandableTableApp";
import CustomTh from "./CustomTh";
import CustomTd from "./CustomTd";
import CustomTr from "./CustomTr";
import {CHECKBOX_TABLE_WIDTH, EXPANDED_ROW_CLASS} from "./Model/TableModel";

// Utility: Access nested object fields like 'user.profile.name'
const getValueByPath = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
};

const CustomExpandableTable = ({
                                   id = "tbl_cet_accordion",
                                   columns, // Array: Defines the table columns. Each object should contain `field`, `label`, and optionally `render` for custom rendering.
                                   rows, // Array: The data to render in the table rows.
                                   renderExpandedRow, // Function (Optional): A function that returns the content to show when a row is expanded.
                                   renderOptionsMenu, // Function (Optional): A function that returns action elements (e.g., menu or buttons) for each row.
                                   onRowExpand, // Function (Optional): A callback triggered when a row is expanded.
                                   handleCheckboxChange, // Function: Called when an individual row checkbox is toggled.
                                   selectedList = [], // Array: IDs of currently selected rows.
                                   rowsPerPage, // Number: Determines how many rows should be displayed per page.
                                   handleDeleteAll,  // Function: Callback executed when the "delete all selected rows" action is triggered.
                                   checkbox = true, // Boolean: Enables or disables the checkbox column. If false, no checkboxes are shown.
                                   deSelectAllId = 'cb_cet_de_select_all',// Id for the "deselect all" checkbox.
                                   tooltip = true,// Boolean: Determines whether tooltips are shown on elements within the table.
                                   placement = 'top-start', // String: Tooltip placement position (e.g., 'top', 'bottom', 'left', 'right').
                                   className='',
                                   showHeader = true,   // Boolean: Controls whether the table header is displayed.
                                   rowClassName = null, // Optional callback that allows assigning dynamic CSS classes to table rows.
                                   classNameRenderContainer='',
                                   withoutHeight=false // Boolean: Disables the automatic height calculation and the dynamic positioning of the accordion popper.
                               }) => {


    const {
        t,
        elementRef,
        tbodyRef,
        openRowId,
        toggleRow
    } = CustomExpandableTableApp({
        tableId:id,
        checkbox,
        thead: columns,
        tbody: rows,
        onRowExpand,
        withoutHeight,
    });

    return (
        <Box className={'custom-panel-table'}>
            <Box sx={CustomStyleTable} ref={elementRef}>
                <table id={id} className={`custom-scroll-table w-100 custom-scrollbar ${!showHeader ? 'mt-negative-30px' : ''}`}>
                    <thead className={`${!showHeader ? 'collapse-visibility': ''}`}>
                        <tr>
                        {checkbox &&
                            <CustomTh tableId={id} fixedXY={true} left={0} classes='checkbox-table checkbox-fixed' customWidth={CHECKBOX_TABLE_WIDTH}>
                                <CustomCheckbox
                                    id={deSelectAllId}
                                    checked={rows?.slice(0, rowsPerPage).every((row) => selectedList.includes(row?.id))}
                                    indeterminate={
                                        selectedList.length > 0 &&
                                        !rows.slice(0, rowsPerPage).every((row) => selectedList.includes(row?.id))
                                    }
                                    onChange={(e) => {
                                        handleDeleteAll(e)
                                    }}
                                />
                            </CustomTh>
                        }
                        {columns.map((col) => (
                                <CustomTh
                                    key={col.label}
                                    tableId={id}
                                    classes={col.className}
                                    fixedXY={col?.fixed}
                                    left={col?.left}
                                    customWidth={col?.customWidth}
                                >
                                    {t(`${col.label}`)}
                                </CustomTh>
                        ))}
                        {renderOptionsMenu &&
                            <CustomTh tableId={id} classes={"justify-center-th"}>{t('options')}</CustomTh>
                        }
                        {renderExpandedRow &&
                            <CustomTh tableId={id} classes={"justify-center-th"}>{t('see_more')}</CustomTh>
                        }
                        </tr>
                    </thead>
                    <tbody ref={tbodyRef}>
                        {rows?.map((row) => (
                            <React.Fragment key={row.id}>
                                <CustomTr classes={` ${openRowId === row?.id ? 'row-active' : ''}  ${selectedList?.map(String).includes(String(row?.id)) ? 'row-selected' : ''}  ${rowClassName ? rowClassName(row) : ''} `}>
                                    { checkbox &&
                                        <CustomTd
                                            tableId={id}
                                            fixed={true}
                                            left={0}
                                            classes={`checkbox-table`}
                                        >
                                            <CustomTooltip text={row?.disabledCheckboxText}>
                                                <CustomCheckbox
                                                    id={"cb_cet_row_" + row?.id}
                                                    checked={selectedList.includes(row?.id)}
                                                    onChange={(e) => {
                                                        if (!row || !row.id) return;
                                                        handleCheckboxChange({target: {id: row.id, checked: e.target.checked}});
                                                    }}
                                                    disabled={row?.disabled || false}
                                                />
                                            </CustomTooltip>
                                        </CustomTd>
                                    }
                                    {columns.map((col, index) => {
                                        let value = getValueByPath(row, col?.field);

                                        if (typeof value === 'number' && value > 1_000_000_000_000) {
                                            value = getDateFormat(
                                                value,
                                                typeof col?.datetime === "undefined" ? true : col?.datetime,
                                                col?.dateFormat
                                            );
                                        }
                                        return (
                                            <CustomTd
                                                tableId={id}
                                                key={col.field}
                                                classes={`${index === 0 ? 'first-column' : ''} ${col.classTableCell}`}
                                                fixed={col?.fixed}
                                                left={col?.left}
                                            >
                                                <EllipsisCell
                                                    value={value}
                                                    render={(val) => col.render ? col.render(val, row) : val}
                                                    tooltip={tooltip}
                                                    placement={placement}
                                                    className={col?.className}
                                                    classNameContainerTooltip={col?.classNameContainerTooltip}
                                                    classNameTooltip={col?.classNameTooltip}
                                                    classNameSubTextTooltip={col?.classNameSubTextTooltip}
                                                />
                                            </CustomTd>
                                        );
                                    })}
                                    {renderOptionsMenu &&
                                        <CustomTd tableId={id}>
                                            <div className={"tableIcon"}>
                                                {renderOptionsMenu(row)}
                                            </div>
                                        </CustomTd>
                                    }
                                    {renderExpandedRow && (
                                        <CustomTd tableId={id}>
                                            <div className={"tableIcon"}>
                                                <IconButton disableRipple>
                                                    {
                                                        openRowId === row?.id ?
                                                            <ArrowDropUpIcon sx={CustomDropdownMenuStyles.iconButton}
                                                                             className={'row-active'}
                                                                             onClick={() => toggleRow(row?.id, row)}
                                                                             size="small"/> :
                                                            <ArrowDropDownIcon sx={CustomDropdownMenuStyles.iconButton}
                                                                               onClick={() => toggleRow(row?.id, row)}
                                                                               size="small"/>
                                                    }
                                                </IconButton>
                                            </div>
                                        </CustomTd>
                                    )}
                                </CustomTr>
                                {renderExpandedRow && openRowId === row?.id && (
                                    <CustomTr tableId={id} classes={`${EXPANDED_ROW_CLASS} transform-negative-8px`}>
                                        <CustomTd tableId={id} colSpan={columns.length + 3} classes={'p-0 border-0'}>
                                            <Collapse in={openRowId === row?.id} timeout='auto' unmountOnExit>
                                                <Box
                                                    className={`${classNameRenderContainer} p-16px background-shades-50 expanded-row-box`}
                                                >
                                                    {React.createElement(renderExpandedRow, { row })}
                                                </Box>
                                            </Collapse>
                                        </CustomTd>
                                    </CustomTr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </Box>
        </Box>
    );
};

export default CustomExpandableTable;
